const data = {
    mammothMig1: [0, 8, 6, 4, 2, 0],
    mammothMig2: [0, 4, 2, 1, 0, 0],
    squirrelMig: [0, 7, 6, 6, 6, 4],
    mammoth1: [[0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0.50, 0],
        [0.50, 0.50, 0.80, 1.10, 1.10, 0],
        [1.10, 1.10, 1.10, 1.10, -1, 0],
        [1.10, 1.10, 1.10, 1.10, -1, 0],
        [1.10, 1.10, 1.10, 1.10, -1, 0],
        [1.10, 1.10, 1.10, 0.50, -1, 0],
        [1.10, 1.10, 1.10, -1, 0, 0],
        [1.10, 1.10, 1.10, -1, 0, 0],
        [1.10, 1.10, 1.10, -1, 0, 0],
        [1.10, 1.10, 1.10, -1, 0, 0],
        [1.10, 1.10, 1.10, -1, 0, 0],
        [1.10, 1.10, 0.50, -1, 0, 0],
        [1.10, 1.10, -1, 0, 0, 0],
        [1.10, 0.50, -1, 0, 0, 0],
        [1.10, -1, 0, 0, 0, 0],
        [1.10, -1, 0, 0, 0, 0],
        [0.50, -1, 0, 0, 0, 0]],

    mammoth2: [[0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0.70, 0.70, 0.70, 0.60, 0, 0],
        [0.60, 0.60, 0.60, 0.60, 0, 0],
        [0.60, 0.60, 0.60, 0.60, 0, 0],
        [0.60, 0.60, 0.60, 0.60, 0, 0],
        [0.60, 0.60, 0.60, 0.35, 0, 0],
        [0.60, 0.60, 0.60, -1, 0, 0],
        [0.60, 0.60, 0.60, -1, 0, 0],
        [0.60, 0.60, 0.60, -1, 0, 0],
        [0.60, 0.60, 0.60, -1, 0, 0],
        [0.60, 0.60, 0.60, -1, 0, 0],
        [0.60, 0.60, 0.35, -1, 0, 0],
        [0.60, 0.60, -1, 0, 0, 0],
        [0.60, 0.35, -1, 0, 0, 0],
        [0.60, -1, 0, 0, 0, 0],
        [0.60, -1, 0, 0, 0, 0],
        [0.35, -1, 0, 0, 0, 0]],

    squirrel: [[0, 0, 0, 0, 1.10, 1.10],
        [0, 0, 0, 1.10, 1.10, 1.10],
        [0, 0, 1.10, 1.10, -1, 0],
        [0, 1.10, 1.10, 1.10, -1, 0],
        [1.10, 1.10, 1.10, -1, 0, 0],
        [1.10, 1.10, -1, 0, 0, 0],
        [1.10, 1.10, -1, 0, 0, 0],
        [1.10, -1, 0, 0, 0, 0],
        [1.10, -1, 0, 0, 0, 0],
        [0.50, -1, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0]],
};

export default data;
